export default __webpack_public_path__ + "static/media/feb2024-4.7b717e10.jpg";